<template>
  <div class="background">
    <v-fade-transition>
      <div v-if="activeSubscription">
        <prices-home v-if="!page || page == 'calculator'"></prices-home>
        <price-list v-if="page == 'pricelist'"></price-list>
        <!-- <div v-else-if="page == 'settings'">settings {{ page }}</div> -->
        <!-- <price-settings-home
          v-else-if="page == 'settings'"
        ></price-settings-home> -->
        <div v-else>{{ page }}</div>
      </div>
      <div v-else>
        <v-card class="mx-auto my-6 text-center" flat max-width="500">
          This is EyeDock Pro feature. Log in or register to use the contact
          lens price calculator.
          <!-- learn more -->
          <user-login :textButton="false" class="my-4"></user-login>
        </v-card>

        <!-- put a page explaining this module here -->
      </div>
    </v-fade-transition>
  </div>
</template>

<script>
// import LensSearch from "../components/LensSearch";
//import FamilyLensSelector from "../components/FamilyLensSelector";
// import axios from "axios";
import PricesHome from "@/components/clPricesStuff/PricesHome";
import UserMixin from "@/assets/js/UserMixin";
// import PriceSettingsHome from "./PriceSettingsHome.vue";

// import LoginForm from "../components/userManagement/LoginForm";

export default {
  name: "ClPricesHome",
  components: {
    PricesHome,
    UserLogin: () => import("@/components/universalStuff/UserLogin"),
    PriceList: () => import("@/components/clPricesStuff/PriceList"),
    // PriceSettingsHome: () =>
    //   import("@/components/pricesStuff/PriceSettingsHome"),
  },
  mixins: [UserMixin],
  data: () => ({
    userData: null,
    page: null,
  }),
  computed: {
    validUser: function () {
      let userData = this.$store.state.userAmember;
      return userData && userData.ok;
    },
  },
  mounted() {
    this.page = this.$route.params.page;
    console.log("page", this.page);
  },
  created() {
    if (!this.$store.state.clCompanies) this.$store.dispatch("loadCompanies");
  },
  metaInfo() {
    return {
      title: "EyeDock/CL Price Calculator",
    };
  },
};
</script>

<style>
.background {
  /* background-color: #f2f9ff; */
  padding-bottom: 200px;
}
</style>
